"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var _10;
var client_lib_js_player_addons_common_player_1 = require("@sky-uk-ott/client-lib-js-player-addons-common-player");
var client_lib_js_player_framework_utils_1 = require("@sky-uk-ott/client-lib-js-player-framework-utils");
var uwp_media_remote_service_1 = require("./uwp-media-remote-service");
var KEY_CODE_MAP = (_10 = {},
    _10[client_lib_js_player_framework_utils_1.CTV_KEY.UP] = [203, 211, 38],
    _10[client_lib_js_player_framework_utils_1.CTV_KEY.DOWN] = [204, 212, 40],
    _10[client_lib_js_player_framework_utils_1.CTV_KEY.LEFT] = [205, 214, 37],
    _10[client_lib_js_player_framework_utils_1.CTV_KEY.RIGHT] = [206, 213, 39],
    _10[client_lib_js_player_framework_utils_1.CTV_KEY.ENTER] = [195, 13],
    _10[client_lib_js_player_framework_utils_1.CTV_KEY.BACK] = [196, 27],
    _10[client_lib_js_player_framework_utils_1.CTV_KEY.FF] = [202],
    _10[client_lib_js_player_framework_utils_1.CTV_KEY.RW] = [201],
    _10[client_lib_js_player_framework_utils_1.CTV_KEY.DELETE] = [197],
    _10[client_lib_js_player_framework_utils_1.CTV_KEY.START] = [207],
    _10[client_lib_js_player_framework_utils_1.CTV_KEY.L3] = [209],
    _10[client_lib_js_player_framework_utils_1.CTV_KEY.Y] = [198],
    _10._0 = [48],
    _10._1 = [49],
    _10._2 = [50],
    _10._3 = [51],
    _10._4 = [52],
    _10._5 = [53],
    _10._6 = [54],
    _10._7 = [55],
    _10._8 = [56],
    _10._9 = [57],
    _10._a = [65],
    _10._b = [66],
    _10._c = [67],
    _10._d = [68],
    _10._e = [69],
    _10._f = [70],
    _10._g = [71],
    _10._h = [72],
    _10._i = [73],
    _10._j = [74],
    _10._k = [75],
    _10._l = [76],
    _10._m = [77],
    _10._n = [78],
    _10._o = [79],
    _10._p = [80],
    _10._q = [81],
    _10._r = [82],
    _10._s = [83],
    _10._t = [84],
    _10._u = [85],
    _10._v = [86],
    _10._w = [87],
    _10._x = [88],
    _10._y = [89],
    _10._z = [90],
    _10[client_lib_js_player_framework_utils_1.CTV_KEY.SHORTCUT_1] = [197],
    _10[client_lib_js_player_framework_utils_1.CTV_KEY.SHORTCUT_2] = [198],
    _10[client_lib_js_player_framework_utils_1.CTV_KEY.SHORTCUT_3] = [207],
    _10[client_lib_js_player_framework_utils_1.CTV_KEY.SHORTCUT_4] = [200],
    _10[client_lib_js_player_framework_utils_1.CTV_KEY.SHORTCUT_6] = [209],
    _10[client_lib_js_player_framework_utils_1.CTV_KEY.SHORTCUT_5] = [199],
    _10[client_lib_js_player_framework_utils_1.CTV_KEY.SHORTCUT_7] = [201],
    _10[client_lib_js_player_framework_utils_1.CTV_KEY.SHORTCUT_8] = [209],
    _10[client_lib_js_player_framework_utils_1.CTV_KEY.SHORTCUT_9] = [207],
    _10[client_lib_js_player_framework_utils_1.CTV_KEY.PLAY] = [uwp_media_remote_service_1.MEDIA_REMOTE_KEY_CODE.PLAY],
    _10[client_lib_js_player_framework_utils_1.CTV_KEY.SKIP_NEXT] = [uwp_media_remote_service_1.MEDIA_REMOTE_KEY_CODE.NEXT],
    _10[client_lib_js_player_framework_utils_1.CTV_KEY.SKIP_PREV] = [uwp_media_remote_service_1.MEDIA_REMOTE_KEY_CODE.PREV],
    _10[client_lib_js_player_framework_utils_1.CTV_KEY.PAUSE] = [uwp_media_remote_service_1.MEDIA_REMOTE_KEY_CODE.PAUSE],
    _10[client_lib_js_player_framework_utils_1.CTV_KEY.STOP] = [uwp_media_remote_service_1.MEDIA_REMOTE_KEY_CODE.STOP],
    _10[client_lib_js_player_framework_utils_1.CTV_KEY.FF] = [uwp_media_remote_service_1.MEDIA_REMOTE_KEY_CODE.FF],
    _10[client_lib_js_player_framework_utils_1.CTV_KEY.RW] = [uwp_media_remote_service_1.MEDIA_REMOTE_KEY_CODE.RW],
    _10);
var PREVENT_DEFAULT = new Set([38, 211, 203, 40, 212, 204, 37, 205, 214, 39, 206, 213, 27, 8, 196, 13, 195, 198, 197]);
var UWPInput = (function (_super) {
    __extends(UWPInput, _super);
    function UWPInput(window, messengerService, mediaRemoteService) {
        var _this = _super.call(this, window) || this;
        _this.keyCodeMap = KEY_CODE_MAP;
        _this.preventDefault = PREVENT_DEFAULT;
        messengerService.registerCommand('keydown', function (event) {
            _this.handleKeyDown({
                keyCode: event.data.keyCode,
                preventDefault: function () { return undefined; },
            });
        });
        messengerService.registerCommand('keyup', function (event) {
            _this.handleKeyUp({
                keyCode: event.data.keyCode,
                preventDefault: function () { return undefined; },
            });
        });
        mediaRemoteService.onKeyDown(function (keyCode) {
            _this.handleKeyDown({
                keyCode: keyCode,
                preventDefault: function () { return undefined; },
            });
        });
        mediaRemoteService.onKeyUp(function (keyCode) {
            _this.handleKeyUp({
                keyCode: keyCode,
                preventDefault: function () { return undefined; },
            });
        });
        return _this;
    }
    return UWPInput;
}(client_lib_js_player_addons_common_player_1.Input));
exports.UWPInput = UWPInput;
